import { Injectable } from '@angular/core';

import { PlanProductService } from '@service/planProducts/plan-product.service';
import { AddOnSubscriptionService } from '@service/addOnSubscription/add-on-subscription.service';

/**
 * @author Manish on 18/02/22
 * this service check if a product/feature is enabled in plan product or add on product
 */

@Injectable({
	providedIn: 'root',
})
export class ProductsService {
	constructor(
		private planProductService: PlanProductService,
		private addOnSubscriptionService: AddOnSubscriptionService
	) {}

	get ASSIGN_CARRIERS(): boolean {
		return this.planProductService.ASSIGN_CARRIERS || this.addOnSubscriptionService.ASSIGN_CARRIERS;
	}

	get BOOKING_ASSISTANT(): boolean {
		return (
			this.planProductService.BOOKING_ASSISTANT || this.addOnSubscriptionService.BOOKING_ASSISTANT
		);
	}

	get BOOKING_ASSISTANT_API(): boolean {
		return (
			this.planProductService.BOOKING_ASSISTANT_API ||
			this.addOnSubscriptionService.BOOKING_ASSISTANT_API
		);
	}

	get BULK_MATCHING(): boolean {
		return this.planProductService.BULK_MATCHING || this.addOnSubscriptionService.BULK_MATCHING;
	}

	get C4(): boolean {
		return this.planProductService.C4 || this.addOnSubscriptionService.C4;
	}

	get C4_API(): boolean {
		return this.planProductService.C4_API || this.addOnSubscriptionService.C4_API;
	}

	get CAPACITY_SEARCH(): boolean {
		return this.planProductService.CAPACITY_SEARCH || this.addOnSubscriptionService.CAPACITY_SEARCH;
	}

	get CARRIER_DEVELOPMENT(): boolean {
		return (
			this.planProductService.CARRIER_DEVELOPMENT ||
			this.addOnSubscriptionService.CARRIER_DEVELOPMENT
		);
	}

	get CARRIER_PROFILES(): boolean {
		return (
			this.planProductService.CARRIER_PROFILES || this.addOnSubscriptionService.CARRIER_PROFILES
		);
	}

	get CARRIER_RATES(): boolean {
		return this.planProductService.CARRIER_RATES || this.addOnSubscriptionService.CARRIER_RATES;
	}

	get CARRIER_RECRUITING(): boolean {
		return (
			this.planProductService.CARRIER_RECRUITING || this.addOnSubscriptionService.CARRIER_RECRUITING
		);
	}

	get CUSTOMERS(): boolean {
		return this.planProductService.CUSTOMERS || this.addOnSubscriptionService.CUSTOMERS;
	}

	get HAZMAT(): boolean {
		return this.planProductService.HAZMAT || this.addOnSubscriptionService.HAZMAT;
	}

	get INTEGRATIONS(): boolean {
		return this.planProductService.INTEGRATIONS || this.addOnSubscriptionService.INTEGRATIONS;
	}

	get MULTIPLE_USERS(): boolean {
		return this.planProductService.MULTIPLE_USERS || this.addOnSubscriptionService.MULTIPLE_USERS;
	}

	get PRICING(): boolean {
		return this.planProductService.PRICING || this.addOnSubscriptionService.PRICING;
	}

	get PROJECT_CARRIERS(): boolean {
		return (
			this.planProductService.PROJECT_CARRIERS || this.addOnSubscriptionService.PROJECT_CARRIERS
		);
	}

	get RECENT_TRANSACTIONS(): boolean {
		return (
			this.planProductService.RECENT_TRANSACTIONS ||
			this.addOnSubscriptionService.RECENT_TRANSACTIONS
		);
	}

	get SCORECARDS(): boolean {
		return this.planProductService.SCORECARDS || this.addOnSubscriptionService.SCORECARDS;
	}

	get STRONG_LANES(): boolean {
		return this.planProductService.STRONG_LANES || this.addOnSubscriptionService.STRONG_LANES;
	}

	get TASKS(): boolean {
		return this.planProductService.TASKS || this.addOnSubscriptionService.TASKS;
	}
}
